import { Dialog, IDialogProps } from '@fluentui/react/lib/Dialog';
import { IModalProps } from '@fluentui/react/lib/Modal';
import { getOpxHostApi } from 'owa-opx';
import * as React from 'react';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { getDensity } from 'owa-fabric-theme';

/**
 * This is a wrapper on the Fabric's Dialog which is aware of Opx Scenarios.
 * Ideally we would use this everywhere in OWA so that we don't have to make sure it works in opx scenarios.
 */
export default function OwaDialog(props: React.PropsWithChildren<IDialogProps>) {
    const modalProps: IModalProps | undefined = updateModalProps(props);
    return (
        <ThemeProvider theme={getDensity()}>
            <Dialog {...props} modalProps={modalProps}>
                {props.children}
            </Dialog>
        </ThemeProvider>
    );
}

function updateModalProps(dialogProps: IDialogProps): IModalProps | undefined {
    const modalProps = dialogProps.modalProps;
    if (!isHostAppFeatureEnabled('updateModalProps')) {
        // If it's not OPX Scenario, return the modalProps without any change to it
        return modalProps;
    }

    const opxHostApi = getOpxHostApi();
    if (!opxHostApi.modalOpened) {
        // If the opxHostApi does not have modalOpened defined, then return the modalProps without any change to it
        return modalProps;
    }

    // Until IDialogProps fully removes these various props, we have to check if they're present.
    // Else intended behavior might be overwritten when we create our new functions.
    const onDismissed = modalProps?.onDismissed || dialogProps.onDismissed;
    const onLayerDidMount =
        modalProps?.layerProps?.onLayerDidMount ||
        dialogProps.onLayerDidMount ||
        modalProps?.layerProps?.onLayerMounted ||
        dialogProps.onLayerMounted;

    return {
        ...modalProps,
        onDismissed: () => {
            if (onDismissed) {
                onDismissed();
            }
            opxHostApi.modalOpened?.(false /* isOpened */);
        },
        layerProps: {
            ...modalProps?.layerProps,
            onLayerDidMount: () => {
                if (onLayerDidMount) {
                    onLayerDidMount();
                }
                opxHostApi.modalOpened?.(true /* isOpened */);
            },
        },
    };
}
